const TIMELINE_FINISHED_DOT_CLASS_NAME = 'timeline-finished-dot';
const TIMELINE_ACTIVE_DOT_CLASS_NAME = 'timeline-active-dot';
const TIMELINE_PENDING_DOT_CLASS_NAME = 'timeline-pending-dot';

const TIMELINE_CLASS_NAME = 'timeline';
const TIMELINE_LABEL_CLASS_NAME = 'timeline-label';
const TIMELINE_CAPTION_CLASS_NAME = 'timeline-caption';

export {
  TIMELINE_FINISHED_DOT_CLASS_NAME,
  TIMELINE_ACTIVE_DOT_CLASS_NAME,
  TIMELINE_PENDING_DOT_CLASS_NAME,
  TIMELINE_CLASS_NAME,
  TIMELINE_LABEL_CLASS_NAME,
  TIMELINE_CAPTION_CLASS_NAME,
};
